export const CheckboxContainerTypes = {
  AUCTION_PEN: "auction_pen",
  MLA: "mla",
};
